import {Injectable} from '@angular/core';
import {NetworkCommonService} from '../../common/network-common.service';
import {OfflineNetworkApiService} from '../../../../services/api/network/offline/network/offline-network-api.service';
import * as _ from 'lodash';
import {OfflineConnectionService} from '../connection/offline-connection.service';
import {OfflinePeerConnectionService} from '../peer-connection/offline-peer-connection.service';
import {ConfirmationDialogComponent} from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ClusterDialogComponent} from '../../../map/cluster-dialog/cluster-dialog.component';
import {SnackBarService} from '../../../../services/common/snack-bar/snack-bar.service';
import {OfflineMapService} from '../../map/offline-map/offline-map.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineNetworkService {

  constructor(public dialog: MatDialog,
              private offlineConnectionService: OfflineConnectionService,
              private offlinePconService: OfflinePeerConnectionService,
              private offlineNetworkApiService: OfflineNetworkApiService,
              private snackBarService: SnackBarService,
              private offlineMapService: OfflineMapService) {
  }

  public editCluster(cluster, onOk): void {
    const dialogRef = this.dialog.open(ClusterDialogComponent, {
      data: {
        isEditMode: true,
        selectedItem: cluster
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      dialogRef.close();
      this.snackBarService.display(`"${result.name}" successfully edited`);
      onOk(result);
      this.refreshDiagram();
    });
  }

  public dragOfflineEdge(draggedEdgeObject, illegalDragCallback): void {
    const dragStructure = NetworkCommonService.getDragStructure(draggedEdgeObject);

    if (this.isDragLegalOffline(dragStructure)) {
      if (_.isEqual(dragStructure, 'n2n') || _.isEqual(dragStructure, 'n2t')) {
        this.offlineConnectionService.addConnection(draggedEdgeObject.from.dataItem.id, draggedEdgeObject.to.dataItem.id);
      } else if (_.isEqual(dragStructure, 't2n')) {
        this.offlineConnectionService.addConnection(draggedEdgeObject.to.dataItem.id, draggedEdgeObject.from.dataItem.id);
      } else if (_.isEqual(dragStructure, 't2v')) {
        this.offlinePconService.addVirtualPCon(draggedEdgeObject.from.dataItem.id, draggedEdgeObject.to.dataItem.id);
      } else if (_.isEqual(dragStructure, 'v2t')) {
        this.offlinePconService.addVirtualPCon(draggedEdgeObject.to.dataItem.id, draggedEdgeObject.from.dataItem.id);
      } else if (_.isEqual(dragStructure, 'n2v')) {
        this.offlinePconService.addPcon(draggedEdgeObject.from.dataItem.id, draggedEdgeObject.to.dataItem.id);
      } else {
        this.offlinePconService.addPcon(draggedEdgeObject.to.dataItem.id, draggedEdgeObject.from.dataItem.id);
      }
    } else {
      illegalDragCallback();
    }
  }

  public clearOfflineMap(): void {
    const confirmationMessage = 'Are you sure you want to clear the offline map ?';

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.offlineNetworkApiService.clearOfflineMap().then(() => {
        // this.sharedEventService.broadcast('clearOfflineTestRoute');
        dialogRef.close();
        this.refreshDiagram();
      }).catch(() => {
        dialogRef.close();
      });
    });
  }

  public importFromTopology(): void {
    this.offlineNetworkApiService.importFromTopology().then(() => {
      this.offlineMapService.manualRefresh();
    }).catch(() => {});
  }

  private refreshDiagram(): void {
    this.offlineMapService.refresh();
  }

  private isDragLegalOffline(structure): any {
    const legalDrags = ['n2n', 't2n', 'n2t', 't2v', 'v2t', 'n2v', 'v2n'];
    return legalDrags.indexOf(structure) > -1;
  }
}
